module.exports = __webpack_public_path__ + "static/like-a2e211aa35e842ac5037af76929b2e25.png";